var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"help-text"},[_vm._v("\n\t"+_vm._s(_vm.t('mail', 'Stop ends all processing'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }